import React from 'react'
import { useState, useEffect } from 'react';
import { setLoading } from "../store/feedback";
import '../App.css'
import {
	colors,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	LinearProgress,
	Tooltip,
} from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
// import "../create-button/createButton.css";
import "./createAudit.css"
import { Spin } from "antd";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from 'antd';
import AuditDetails from './auditDetails'
function CreatAudit() {
	const dispatch = useDispatch();
	const [reqUrl, setReqUrl] = useState(null);
	const navigate = useNavigate();
	const [dialogSeverity, setDialogSeverity] = useState("success");
	const { loading } = useSelector((state) => state.feedbackStore);
	const [openDialog, setOpenDialog] = useState(false);

	// const [createAuditModal, setCreateAuditModal] = useState(false)

	const [dialogWidth, setDialogWidth] = useState("29vw");
	const [dialogText, setDialogText] = useState("0.9rem");
	const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`;

	useEffect(() => {
		const handleResize = () => {
			const windowWidth = window.innerWidth;
			if (windowWidth <= 450) {
				setDialogWidth("94vw");
			} else if (windowWidth <= 475) {
				setDialogWidth("94vw");
			} else if (windowWidth <= 570) {
			} else if (windowWidth <= 575) {
				setDialogText("0.6rem");
				setDialogWidth("64vw");
			} else if (windowWidth <= 650) {
				setDialogWidth("60vw");
			} else if (windowWidth <= 700) {
			} else if (window.innerWidth <= 775) {
				setDialogWidth("57vw");
			} else if (window.innerWidth <= 875) {
				setDialogWidth("55vw");
			} else if (windowWidth <= 1000) {
				setDialogWidth("48vw");
			} else if (window.innerWidth <= 1100) {
				setDialogWidth("45vw");
				setDialogText("0.8rem");
			} else if (windowWidth <= 1300) {
				setDialogWidth("40vw");
			} else {
				setDialogWidth("35vw");
			}
		};

		window.addEventListener("resize", handleResize);

		handleResize();

		// Cleanup function to remove event listener
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleDialogClose = (event) => {
		// if (
		//   event.target.tagName.toLowerCase() !== "button" &&
		//   !event.target.closest("button")
		// ) {

		//   return;
		// }

		setOpenDialog(false);
	};
	const showAlert = (severity, message) => {
		setDialogSeverity(severity);
		setOpenDialog(true);
	};

	const generateRandomId = () => {
		const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		let result = "";

		for (let i = 0; i < 4; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			result += characters[randomIndex];
		}

		const now = new Date();
		const year = now.getFullYear().toString().slice(-2); // Last 2 digits of year
		const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Month (1-12) padded to 2 digits
		const day = now.getDate().toString().padStart(2, "0"); // Day padded to 2 digits
		const hours = now.getHours().toString().padStart(2, "0"); // Hours padded to 2 digits
		const mins = now.getMinutes().toString().padStart(2, "0"); // Minutes padded to 2 digits

		const secs = now.getSeconds().toString().padStart(2, "0"); // Seconds padded to 2 digits

		const dateTimePart = day + hours + mins + secs;

		result += dateTimePart;
		return result.slice(0, 12);
	};

	const handleCopy = () => {
		navigator.clipboard.writeText(reqUrl);
	};
	const handleViewAudit = () => {
		navigate("/view-audit")
	}
	const handleCreateAudit = async () => {

		return
		const audit = generateRandomId();
		console.log(audit);
		try {
			dispatch(setLoading(true));
			const res = await axios.post("/create_audit/get_token", {
				auditID: audit,
			});
			const hostname = window.location.hostname;
			const port = window.location.port;
			const baseURL = `https://${hostname}:${port}`;
			const url = `${baseURL}/audit/${audit}`;
			setReqUrl(url);
			console.log(url, "121")
			showAlert("success", "Audit created successfully");
			dispatch(setLoading(false));
		} catch (err) {
			console.log(err);
			dispatch(setLoading(false));
		}
	};
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	const updateMedia = () => {
		setIsMobile(window.innerWidth <= 768);
	};

	useEffect(() => {
		window.addEventListener('resize', updateMedia);
		return () => window.removeEventListener('resize', updateMedia);
	}, []);
	return (
		<div className='hide-scrollbar'>
			<div>
				<div style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100%',
					height: '100%',
					// marginLeft: "20px",
					overflow: "auto",
					marginTop: "10px"
				}}>
					<AuditDetails />
				</div>
			</div>

			<Dialog
				open={openDialog}
				onClose={handleDialogClose}
				maxWidth="150vw"
				maxHeight="lg"
				PaperProps={{
					style: {
						width: dialogWidth,
						padding: "1.5rem 1rem",
						paddingBottom: "0.5rem",
						borderRadius: "4px",
						margin: "0px",
						height: "265px"
					},
				}}
			>
				<DialogTitle
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
						gap: "1rem",
						fontSize: "1.9rem",
						textAlign: "center",
						color: "black",
						padding: "2rem 0.6rem 1rem 0.6rem",
						fontWeight: "600",
						fontFamily: 'Barlow Condensed',
					}}
				>
					{dialogSeverity === "success"
						? "Audit created successfully"
						: "Error"}
					<button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0.2rem 1.2rem", backgroundColor: "white", borderRadius: "5px", width: "100%" }}>
						<img src={share} style={{ width: "1rem", height: "1rem" }}></img>
						<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }} onClick={handleCopy} >Copy Link</p>
					</button>
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleDialogClose}
					sx={{
						position: "absolute",
						right: 14,
						top: 30,
						color: "black",

					}}
				>
					<CloseIcon />
				</IconButton>
				<div style={{ padding: "0.4rem 0.6rem" }}>
					<p style={{ color: "#FC350B", textDecoration: "underline", fontFamily: "'Montserrat', sans-serif", marginBottom: "2px" }}>{reqUrl}url text</p>
				</div>


			</Dialog>
		</div>
	);

}

export default CreatAudit